import { Record } from "immutable";

export default Record({
  uid: "",
  email: "",
  avatar: {},
  fullName: "",
  is2FA: false,
  groups: []
});



// WEBPACK FOOTER //
// ./src/common/users/currentUser.js